/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SolicitarViaAliases {
  AUTOCOMPLETE_MOTIVO = 'autocomplete-motivo',
  BUTTON_CONFIRMAR = 'button-confirmar',
  CARD_0 = 'card-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  CUSTOM_CARD = 'custom-card',
  DECK_0 = 'deck-0',
  FETCH_DADOS = 'fetch-dados',
  FETCH_SOLICITAR = 'fetch-solicitar',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_4 = 'field-4',
  FIELD_6 = 'field-6',
  FIELD_ANEXOS = 'field-anexos',
  FILE_UPLOADER = 'file-uploader',
  FORM_SOLICITAR = 'form-solicitar',
  LAYOUT_SOLICITAR_VIA = 'layout-solicitar-via',
  LOADER_0 = 'loader-0',
  MAPPER_0 = 'mapper-0',
  PANEL_0 = 'panel-0',
  PANEL_CONFIRMAR = 'panel-confirmar',
  PANEL_CONSULTA = 'panel-consulta',
  PANEL_LOADER = 'panel-loader',
  PANEL_SOLICITAR = 'panel-solicitar',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_5 = 'text-5',
}
export { SolicitarViaAliases };
